import config from "config";
import { usePodcastProvider } from "./PodcastProvider";
//ui
import { Flex, Image } from "@chakra-ui/react";

export function Banner() {
  const { isOpen, playPodcast } = usePodcastProvider();
  const showComponents = isOpen ? "none" : "flex";

  return (
    <Flex width="100%">
      {config?.companyLogoUrl && (
        <Image
          src={config?.companyLogoUrl}
          alt="Banner Image"
          width="100%"
          maxHeight={{ base: "280px", sm: "326px" }}
          minHeight={{ base: "280px", sm: "326px" }}
          borderBottomRadius="56px"
          objectFit="cover"
          mt={playPodcast ? "-72px" : "0px"}
          display={{ base: showComponents, md: "flex" }}
        />
      )}
    </Flex>
  );
}
